import React from 'react';
import { useTranslate } from '@translations/useTranslate';
import SubFooterStyles from './SubFooter.module.scss';

export const SubFooter: React.FC = () => {
  const { t } = useTranslate();
  return (
    <div className={SubFooterStyles.sub_footer} dir="auto">
      {t('footer.sub')}
    </div>
  );
};
